"use client"
import { useSnackbar } from '@/contexts/SnackbarContext'
import { useUser } from '@/contexts/UserContext'
import { signout } from '@/helpers/Functions/TopLevel'
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from '@nextui-org/react'
import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import router from 'next/router'
import React from 'react'
import { MdAccountCircle } from 'react-icons/md'

const AccountBtn = ({
    signedIn,
    setSignedIn,
    pathName,
    router
}: {
    signedIn: boolean,
    setSignedIn: React.Dispatch<React.SetStateAction<boolean>>,
    pathName: string
    router: any
}) => {
    const { showSnackbar } = useSnackbar()
    const pathname = usePathname()
    const { mychaivio } = useUser();
    const searchParams = useSearchParams()
    return (
        <>
            {
                mychaivio ?
                    <Dropdown>
                        <DropdownTrigger>
                            <button className="bg-transparent max-w-8 w-8 h-8">
                                <MdAccountCircle size={32} color="#000000" />
                            </button>
                        </DropdownTrigger>
                        <DropdownMenu aria-label="Static Actions">
                            <DropdownItem onClick={() => router.push("/orders")} key="orders" className={`w-full h-full ${pathName === "/orders" ? "text-amber-500" : ""}`}>Orders</DropdownItem>
                            <DropdownItem onClick={() => router.push("/favourites")} key="favourites" className={`w-full h-full ${pathName === "/favourites" ? "text-amber-500" : ""}`}>Favourites</DropdownItem>

                            <DropdownItem onClick={() => router.push("/admin")} key="admin" className={`w-full h-full ${pathName === "/admin" ? "text-amber-500" : ""}`}>Admin</DropdownItem>

                            <DropdownItem key="delete" >

                                {
                                    signedIn ?
                                        <button className="p-2 bg-red-400 text-white w-full rounded-lg" onClick={() => signout(setSignedIn, showSnackbar)}>
                                            Sign Out
                                        </button>
                                        :
                                        <button className="w-full bg-black px-4 py-2 rounded-lg text-white">
                                            <Link className="min-w-full" href={`/auth?redirect=${pathname}${searchParams.size > 0 ? `?${searchParams}` : ''}`}>
                                                Sign In
                                            </Link>
                                        </button>
                                }
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                    : <Dropdown>
                        <DropdownTrigger>
                            <button className="bg-transparent max-w-8 w-8 h-8">
                                <MdAccountCircle size={32} color="#000000" />
                            </button>
                        </DropdownTrigger>
                        <DropdownMenu aria-label="Static Actions">
                            <DropdownItem onClick={() => router.push("/orders")} key="orders" className={`w-full h-full ${pathName === "/orders" ? "text-amber-500" : ""}`}>Orders</DropdownItem>
                            <DropdownItem onClick={() => router.push("/favourites")} key="favourites" className={`w-full h-full ${pathName === "/favourites" ? "text-amber-500" : ""}`}>Favourites</DropdownItem>
                            <DropdownItem key="delete" >

                                {
                                    signedIn ?
                                        <button className="p-2 bg-red-400 text-white w-full rounded-lg" onClick={() => signout(setSignedIn, showSnackbar)}>
                                            Sign Out
                                        </button>
                                        :
                                        <button className="w-full bg-black px-4 py-2 rounded-lg text-white">
                                            <Link className="min-w-full" href={`/auth?redirect=${pathname}${searchParams.size > 0 ? `?${searchParams}` : ''}`}>
                                                Sign In
                                            </Link>
                                        </button>
                                }
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
            }
        </>
    )
}

export default AccountBtn